import AppRoutes from "./routes/routes";
import React from "react";

const App = () => {
  return <AppRoutes />;
};

export default App;
